// updateMembersWorkoutsSelectedEquipment
export const updateMembersWorkoutsSelectedEquipment = (state, { payload }) => {
	state.membersWorkoutsSelectedEquipment = payload;
};

// 	updateMembersWorkoutsSelectedTrainers,
export const updateMembersWorkoutsSelectedTrainers = (state, { payload }) => {
	state.membersWorkoutsSelectedTrainers = payload;
};

// 	updateMembersWorkoutsSelectedMusic,
export const updateMembersWorkoutsSelectedMusic = (state, { payload }) => {
	state.membersWorkoutsSelectedMusic = payload;
};
// 	updateMembersWorkoutsSelectedDuration,
export const updateMembersWorkoutsSelectedDuration = (state, { payload }) => {
	state.membersWorkoutsSelectedDuration = payload;
};
